import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import google from "../images/google-logo.png";
import { FaStar } from "react-icons/fa";

const reviews = [
  {
    name: "Alice Johnson",
    review:
      "Amazing service! The car was clean, and the staff was very helpful.",
  },
  {
    name: "Ben Smith",
    review: "A seamless experience from booking to drop-off. Highly recommend!",
  },
  {
    name: "Clara Lee",
    review: "Great pricing and customer support. Will rent again!",
  },
  {
    name: "David Kim",
    review:
      "Very smooth pickup and return process. Appreciated the quick support.",
  },
  {
    name: "Ella Martinez",
    review: "Cars are well-maintained. Booking took just a few clicks.",
  },
];

function CustomerReviews() {
  return (
    <div className="max-w-7xl mx-auto bg-[#EDEBEC] py-12 px-4 sm:px-6 md:px-8">
      <style>
        {`
          .swiper-pagination-bullet {
            background-color: #006039 !important;
          }
        `}
      </style>
      {/* //when add reviews make it justify between */}
      <div className="flex flex-col lg:flex-row items-center justify-center  gap-10">
        {/* Text Section */}
        <div className="w-full lg:w-1/2 text-center text-[#006039]">
          <p className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-2">
            What Our Customers Say
          </p>
          <p className="text-sm sm:text-base mb-2">
            Join thousands of satisfied customers who trust Aombre for their
            rental needs
          </p>
          <p className="text-lg font-medium sm:text-xl">Great</p>

          <div className="flex justify-center items-center gap-1 my-2">
            {Array(5)
              .fill()
              .map((_, index) => (
                <FaStar key={index} className="text-[#FFD700]" />
              ))}
          </div>

          <img src={google} alt="google" className="mx-auto w-24 h-auto" />

          <p className="text-sm sm:text-base">Based on 4500+ reviews</p>
        </div>

        {/* Swiper Section */}
        {/* <div className="w-full lg:w-1/2">
          <Swiper
            modules={[Pagination]}
            spaceBetween={15}
            slidesPerView={1.1}
            centeredSlides={true}
            pagination={{ clickable: true }}
            breakpoints={{
              640: {
                slidesPerView: 1.2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 1.5,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
            }}
            className="max-w-full"
          >
            {reviews.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="bg-white rounded-xl p-6 mx-2 h-full min-h-[180px] flex flex-col justify-between">
                  <p className="text-gray-700 italic text-sm sm:text-base">
                    "{item.review}"
                  </p>
                  <p className="mt-4 text-right font-semibold text-[#ca8032]">
                    - {item.name}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div> */}
      </div>
    </div>
  );
}

export default CustomerReviews;
